import React, { useCallback, useMemo, useState } from 'react';
import {
  type MRT_ColumnDef,
} from 'material-react-table';
import { Box, Button, Grid } from '@mui/material';
import { MaterialTransferido } from '@/shared/interfaces';
import { Visibility } from '@mui/icons-material';
import { ScrollableDialogProps } from '../Dialogs';
import SampleTable from '../SampleTable';


type SerieDetalle = {
  serie: string;
  cantidad: string;
};

interface InfoProductoPorSeriesProps {
  data: MaterialTransferido[];
}

export const InfoProductoPorSeries: React.FC<InfoProductoPorSeriesProps> = ({ data }) => {

  const [open, setOpen] = useState(false);


  const columns = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        id: 'codigo',
        accessorKey: 'codigo',
        header: 'Cod Producto',
      },
      {
        id: 'descripcion',
        accessorKey: 'producto_data.descripcion',
        header: 'descripcion',
      },
    ],
    [],
  );

  // El detalle de series se renderiza con SampleTable virtualizado en lugar de
  // una tabla plana: un producto puede traer miles de series y pintarlas todas
  // de golpe, sin key por fila, era lo que impedia verlas completas.
  const columnsSeries = useMemo<MRT_ColumnDef<SerieDetalle>[]>(
    () => [
      {
        id: 'serie',
        accessorKey: 'serie',
        header: 'SERIE',
        size: 300,
      },
      {
        id: 'cantidad',
        accessorKey: 'cantidad',
        header: 'CANTIDAD',
        size: 120,
      },
    ],
    [],
  );

  const seriesData = useCallback(
    (data: MaterialTransferido): SerieDetalle[] => {
      const useSeriesMetros = !!data.series_metros;
      const series = data.series ?? [];

      return series.map((serie) => {

        const [baseSerie] = serie.split("-SUB-");
        const cantidad =
          useSeriesMetros
            ? data.series_metros?.[baseSerie] ?? "1"
            : "1";

        return {
          serie,
          cantidad,
        };
      });
    },
    []
  );


  return (

    <>
      <Button
        color="primary"
        endIcon={<Visibility />}
        onClick={() => {
          setOpen(true)
        }}
      >
        VER SERIES
      </Button>


      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="🔎Producto/Series"
            minWidth="48%"
            contentNode={
              <Grid container spacing={3}>

                <Grid item xs={12}>

                  <SampleTable<MaterialTransferido>
                    isLoading={false}
                    data={data || []}
                    columns={columns}
                    enablePagination
                    renderDetailPanel={({ row }) => {
                      if (!row.original.series?.length) return undefined;

                      return (
                        <Box
                          sx={{
                            bgcolor: 'background.default',
                            width: '100%',
                          }}
                        >
                          <SampleTable<SerieDetalle>
                            density="compact"
                            columns={columnsSeries}
                            data={seriesData(row.original)}
                            enableVirtualization
                            enableSticky
                            maxHeight={420}
                            enableTopToolbar
                          />
                        </Box>
                      );
                    }}
                  />

                </Grid>
              </Grid>
            }
          />
        )
      }


    </>

  );
};
